import { ElectricMobilityPackageDto, PowerIncreasePackages } from '@/models';

export interface PowerIncreasePackagesState {
  powerIncreasePackages: ElectricMobilityPackageDto[] | null
}

export const InitialState: PowerIncreasePackagesState = {
  powerIncreasePackages: null
}